var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['zg-border', {
    [`zg-border--border-${_vm.border}`]: _vm.border,
    [`zg-border--background-color-${_vm.backgroundColor}`]: _vm.backgroundColor,
    [`zg-border--border-color-${_vm.borderColor}`]: _vm.borderColor,
    'zg-border--flipped-x': _vm.flippedX,
    'zg-border--flipped-y': _vm.flippedY
  }]},[_c(_vm.borderComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }